import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Alert, Snackbar } from "@mui/material";
import UtilsFormule from "../utils/UtilsFormule";
import JournalCaisseService from "../services/PosService/JournalCaisseService";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";
import CashRegisterService from "../services/PosService/CashRegisterService";
import toastr from "toastr";
const DataTableJournauxCashRegister = ({ journauxCaisse, userRole, onGetJournauxByFiltersHandler }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { SearchBar } = Search;
  const [row, setRow] = useState(null);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [modalVisible, setModalVisible] = useState(false);
  const [creationDate, setCreationDate] = useState(null);
  const [totalCard, setTotalCard] = useState(null);
  const [totalCarteCadeau, setTotalCarteCadeau] = useState(null);
  const [totalCash, setTotalCash] = useState(null);
  const [totalCheck, setTotalCheck] = useState(null);
  const [totalVirement, setTotalVirement] = useState(null);
  const [totalPass, setTotalPass] = useState(null);
  const [totalRSS, setTotalRSS] = useState(null);
  const [totalTPEPASS, setTotalTPEPASS] = useState(null);
  // saisie 
  const [incomeCard, setIncomeCard] = useState(null);
  const [incomeCarteCadeau, setIncomeCarteCadeau] = useState(null);
  const [incomeCash, setIncomeCash] = useState(null);
  const [incomeCheck, setIncomeCheck] = useState(null);
  const [incomeVirement, setIncomeVirement] = useState(null);
  const [incomePass, setIncomePass] = useState(null);
  const [incomeRSS, setIncomeRSS] = useState(null);
  const [incomeTPEPASS, setIncomeTPEPASS] = useState(null);

  const handleModalClose = () => {
    setModalVisible(false);
  };

  const handleModalOpen = () => {
    setModalVisible(true);
  };

  const handleSaveEnregistrer = () => {
    const data = {
      creationDate: creationDate + ":00",
      idJournal:row?.id,
      idCashRegister:row?.cashRegisterId,
      refJournal: row?.ref,
      totalCard: totalCard,
      totalCarteCadeau: totalCarteCadeau,
      totalCash: totalCash,
      totalCheck: totalCheck,
      totalVirement: totalVirement,
      // totalPass: totalPass,
      totalRSS: totalRSS,
      // totalTPEPASS: totalTPEPASS,
      incomeCard: incomeCard,
      incomeCarteCadeau: incomeCarteCadeau,
      incomeCash: incomeCash,
      incomeCheck: incomeCheck,
      incomeVirement: incomeVirement,
      // incomePass: incomePass,
      incomeRSS: incomeRSS,
      // incomeTPEPASS: incomeTPEPASS
    };
    CashRegisterService.updateJournalDeCaisse(getCurrentUserId(), data)
      .then(() => {
        onGetJournauxByFiltersHandler();
        toastr.success("Le journal de caisse a été mis à jour avec succès.");
        setModalVisible(false);
      })
      .catch((error) => {
        toastr.error("Une erreur est survenue lors de la mise à jour du journal de caisse.");
        console.error("Error updating journal de caisse:", error);
      });
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  function validationFormatter(cell, row) {
    if (cell == 0) {
      return <span className="badge badge-danger">Non validé</span>;
    } else if (cell == 1) {
      return <span className="badge badge-success">validé</span>;
    }
  }
  function DateFormatter(cell, row) {
    if (cell != null || cell != "") {
      return UtilsFormule.formatDate(cell);
    }
  }
  function buttonValidationFormatter(cell, row) {
    if (cell === 0) {
      return (
        <span>
          <button
            className="btn btn-sm btn-success"
            onClick={() => validerJournalCaisse(row?.id, row?.creationDate)}
          >
            Valider
          </button>
        </span>
      );
    } else {
      return <span>-</span>;
    }
    // else {
    //   if (cell == 1) {
    //     return (
    //       <span>
    //         <button className="btn btn-sm btn-dark" onClick={(e) => {}}>
    //           rendre non validé
    //         </button>
    //       </span>
    //     );
    //   }
    // }
  }
  const columns = [
    {
      dataField: "ref",
      text: "#Référence",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "creationDate",
      text: "CD",
      align: "center",
      formatter: DateFormatter,
      headerAlign: "center",
      headerStyle: () => ({
        width: "20%",
      }),
    },
    {
      dataField: "validate",
      text: "Validation",
      align: "center",
      headerAlign: "center",
      formatter: validationFormatter,
      headerStyle: () => ({
        width: "20%",
      }),
    },
  ];


  if (userRole.includes("DIRECTEUR_MAGASIN") &&localStorage.getItem("typeGetJournaux")==="caisse") {
    columns.push({
      dataField: "validate",
      text: "Actions",
      align: "center",
      headerAlign: "center",
      formatter: buttonValidationFormatter,
      headerStyle: () => ({
        width: "20%",
      }),
    });
  }

  const totalIncomeDetails = (row) => {
    return (
      <>
        <label>Solde initial de caisse : {row?.soldeInitCashRegister || 0}</label>
        <table
          class="table table-striped table-bordered table-sm"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr className="text-center">
              <th style={{ width: "15%" }}>Méthode de paiement</th>
              <th style={{ width: "15%" }}>Valeur Saisie</th>
              <th style={{ width: "15%" }}>Valeur Encaissée</th>
              <th style={{ width: "15%" }}>Difference</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="text-center">Espece</td>
              <td className="text-center">
                {row?.incomeCash || 0}
                {""} TND
              </td>
              <td className="text-center">
                {row?.totalCash || 0} {""}TND
              </td>
              <td className="text-center">
                {row?.differenceCash || 0} {""}TND
              </td>
            </tr>

            <tr>
              <td className="text-center">Cheque</td>
              <td className="text-center">
                {row?.incomeCheck || 0} {""}TND
              </td>
              <td className="text-center">
                {row?.totalCheck || 0} {""}TND
              </td>
              <td className="text-center">
                {row?.differenceCheck || 0} {""}TND
              </td>
            </tr>

            <tr>
              <td className="text-center">Card</td>
              <td className="text-center">
                {row?.incomeCard || 0} {""}TND
              </td>
              <td className="text-center">
                {row?.totalCard || 0} {""}TND
              </td>
              <td className="text-center">
                {row?.differenceCard || 0} {""}TND
              </td>
            </tr>

            <tr>
              <td className="text-center">Carte Cadeau</td>
              <td className="text-center">
                {row?.incomeCarteCadeau || 0} {""}TND
              </td>
              <td className="text-center">
                {row?.totalCarteCadeau || 0} {""}TND
              </td>
              <td className="text-center">
                {row?.differenceCarteCadeau || 0} {""}TND
              </td>
            </tr>

            <tr>
              <td className="text-center">Virement</td>
              <td className="text-center">
                {row?.incomeVirement || 0} {""}TND
              </td>
              <td className="text-center">
                {row?.totalVirement || 0} {""}TND
              </td>
              <td className="text-center">
                {row?.differenceVirement || 0} {""}TND
              </td>
            </tr>
            {/* <tr>
              <td className="text-center">Chèque cadeau</td>
              <td className="text-center">
                {row?.incomePass || 0} {""}TND
              </td>
              <td className="text-center">
                {row?.totalPass || 0} {""}TND
              </td>
              <td className="text-center">
                {row?.differencePass || 0} {""}TND
              </td>
            </tr> */}

            {/* <tr>
              <td className="text-center">TPE chèque cadeau</td>
              <td className="text-center">
                {row?.incomeTPEPASS || 0} {""}TND
              </td>
              <td className="text-center">
                {row?.totalTPEPASS || 0} {""}TND
              </td>
              <td className="text-center">
                {row?.differenceTPEPASS || 0} {""}TND
              </td>
            </tr> */}

            <tr>
              <td className="text-center">Ristourne</td>
              <td className="text-center">
                {row?.incomeRSS || 0} {""}TND
              </td>
              <td className="text-center">
                {row?.totalRSS || 0} {""}TND
              </td>
              <td className="text-center">
                {row?.differenceRSS || 0} {""}TND
              </td>
            </tr>
          </tbody>
        </table>
      </>
    );
  };
  const usersTotalIncomeDetails = (row) => {
    return (
      <>
        <table
          class="table table-striped table-bordered table-sm"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr className="text-center">
              {(userRole.includes("ADMIN") ||
                userRole.includes("DIRECTEUR_MAGASIN")) && (
                  <th style={{ width: "15%" }}>Créé par</th>
                )}
              {userRole.includes("ADMIN") && row.validate === 1 && (
                <>
                  <th style={{ width: "15%" }}>Validé par</th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            <tr>
              {(userRole.includes("ADMIN") ||
                userRole.includes("DIRECTEUR_MAGASIN")) && (
                  <td
                    className="text-center"
                    style={{ backgroundColor: "yellow" }}
                  >
                    {row?.seller?.firstName} {row?.seller?.lastName}
                  </td>
                )}
              {userRole.includes("ADMIN") && row.validate === 1 && (
                <td className="text-center" style={{ backgroundColor: "gray" }}>
                  {row?.userValidate?.firstName} {""} {""} {""}
                  {row?.userValidate?.lastName}
                </td>
              )}
            </tr>
          </tbody>
        </table>
      </>
    );
  };
  const expandRow = {
    renderer: (row) => (
      <div>
        {usersTotalIncomeDetails(row)}
        {totalIncomeDetails(row)}
        {/* {row.validate === 0 && */}
          <div className="d-flex justify-content-end">
            <button className="btn btn-dark" onClick={() => {
              handleModalOpen();
              setCreationDate(new Date(row?.creationDate).toISOString().slice(0, 16))
              setTotalCard(row?.totalCard)
              setTotalCarteCadeau(row?.totalCarteCadeau)
              setTotalCash(row?.totalCash)
              setTotalCheck(row?.totalCheck)
              setTotalVirement(row?.totalVirement)
              // setTotalPass(row?.totalPass)
              setTotalRSS(row?.totalRSS)
              // setTotalTPEPASS(row?.totalTPEPASS)

               setIncomeCard(row?.incomeCard)
              setIncomeCarteCadeau(row?.incomeCarteCadeau)
              setIncomeCash(row?.incomeCash)
              setIncomeCheck(row?.incomeCheck)
              setIncomeVirement(row?.incomeVirement)
              // setIncomePass(row?.incomePass)
              setIncomeRSS(row?.incomeRSS)
              // setIncomeTPEPASS(row?.incomeTPEPASS)
              setRow(row)
            }}>modifier</button>
          </div>
          {/* } */}
      </div>
    ),
    showExpandColumn: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return <b style={{ cursor: "pointer" }}>-</b>;
      }
      return <b style={{ cursor: "pointer" }}>+</b>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <b style={{ cursor: "pointer" }}>-</b>;
      }
      return <b style={{ cursor: "pointer" }}>+</b>;
    },
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ journauxCaisse }) {
    return journauxCaisse;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  const validerJournalCaisse = (idTotalIncome, creationDateIncome) => {
    var dateParse = UtilsFormule.formatDateJournal(creationDateIncome);
    JournalCaisseService.validateJournauxByCaisse(
      localStorage.getItem("idCaisse"),
      getCurrentUserId(),
      idTotalIncome,
      dateParse
    )
      .then((response) => {
        if (response?.data?.success) {
          setOpenSuccessAlert(true);
          setSuccessAlertText(response?.data?.success);
        } else if (response?.data?.error) {
          setOpenErrorAlert(true);
          setErrorAlertText("error : " + response?.data?.error);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("error : " + error);
      });
  };
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Les Journaux Caisse</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={journauxCaisse}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  />
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                  expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
      {/* Modal */}
      <Modal show={modalVisible} onHide={handleModalClose} centered>
        <Modal.Header>
          <Modal.Title>Modifier le Journal de Caisse</Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleModalClose}
            style={{ fontSize: "1.5rem", background: "none", border: "none" }}
          >
            ×
          </button>
        </Modal.Header>
        <Modal.Body>
          {/* Display reference */}
          <p><strong>Journal de Caisse de référence :</strong> {row?.ref}</p>

          {/* Date Input */}
          {/* <Form.Group>
            <Form.Label>Modifier la Date de Création</Form.Label>
            <Form.Control
              type="datetime-local"
              value={creationDate}
              onChange={(e) => setCreationDate(e.target.value)}
            />
          </Form.Group> */}
 {/* Total Cash */}
          <div className="row">
            <div className="col-sm-6">
              <Form.Group>
                <Form.Label>Système Espèce</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  value={totalCash}
                  onChange={(e) => setTotalCash(Number(e.target.value))}
                />
              </Form.Group>
            </div>
            <div className="col-sm-6">
              <Form.Group>
                <Form.Label>Saisie Espèce</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  value={incomeCash}
                  onChange={(e) => setIncomeCash(Number(e.target.value))}
                />
              </Form.Group>
            </div>
          </div>
        
 {/* Total Check */}

          <div className="row">
            <div className="col-sm-6">
              <Form.Group>
                <Form.Label>Système Chèque</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  value={totalCheck}
                  onChange={(e) => setTotalCheck(Number(e.target.value))}
                />
              </Form.Group>
            </div>
            <div className="col-sm-6">
              <Form.Group>
                <Form.Label>Saisie Chèque</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  value={incomeCheck}
                  onChange={(e) => setIncomeCheck(Number(e.target.value))}
                />
              </Form.Group>
            </div>
          </div>

          
  {/* Total Card */}
          <div className="row">
            <div className="col-sm-6">
              <Form.Group>
                <Form.Label>Système TPE</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  value={totalCard}
                  onChange={(e) => setTotalCard(Number(e.target.value))}
                />
              </Form.Group>
            </div>
            <div className="col-sm-6">
              <Form.Group>
                <Form.Label>Saisie TPE</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  value={incomeCard}
                  onChange={(e) => setIncomeCard(Number(e.target.value))}
                />
              </Form.Group>
            </div>
          </div>

         

         {/* Total Carte Cadeau */}
          <div className="row">
            <div className="col-sm-6">
              <Form.Group>
                <Form.Label>Système Carte Cadeau</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  value={totalCarteCadeau}
                  onChange={(e) => setTotalCarteCadeau(Number(e.target.value))}
                />
              </Form.Group>
            </div>
            <div className="col-sm-6">
              <Form.Group>
                <Form.Label>Saisie Carte Cadeau</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  value={incomeCarteCadeau}
                  onChange={(e) => setIncomeCarteCadeau(Number(e.target.value))}
                />
              </Form.Group>
            </div>
          </div>



          {/* Total Virement */}

          <div className="row">
            <div className="col-sm-6">
                 <Form.Group>
            <Form.Label>Système Virement</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              value={totalVirement}
              onChange={(e) => setTotalVirement(Number(e.target.value))}
            />
          </Form.Group>
            </div>
            <div className="col-sm-6">
                 <Form.Group>
            <Form.Label>Saisie Virement</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              value={incomeVirement}
              onChange={(e) => setIncomeVirement(Number(e.target.value))}
            />
          </Form.Group>
            </div>
          </div>
      

         
           <div className="row">
            <div className="col-sm-6">
       <Form.Group>
            <Form.Label>Système Ristourne </Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              value={totalRSS}
              onChange={(e) => setTotalRSS(Number(e.target.value))}
            />
          </Form.Group>
            </div>
            <div className="col-sm-6">
             <Form.Group>
            <Form.Label>Saisie Ristourne </Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              value={incomeRSS}
              onChange={(e) => setIncomeRSS(Number(e.target.value))}
            />
          </Form.Group>
            </div>
          </div>
         {/* <div className="row">
            <div className="col-sm-6">
        <Form.Group>
            <Form.Label>Système TPE Cadeau </Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              value={totalTPEPASS}
              onChange={(e) => setTotalTPEPASS(Number(e.target.value))}
            />
          </Form.Group>
            </div>
            <div className="col-sm-6">
                 <Form.Group>
            <Form.Label>Saisie TPE Cadeau </Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              value={incomeTPEPASS}
              onChange={(e) => setIncomeTPEPASS(Number(e.target.value))}
            />
          </Form.Group>
            </div>
          </div> */}
         
        
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={handleSaveEnregistrer}>
            Enregistrer
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default DataTableJournauxCashRegister;
